module.exports = __webpack_public_path__ + "static/media/politics.1413fc11.svg";